import {Component, OnInit} from '@angular/core';
import {MessageService} from 'primeng/api';
import {ReportXpressService, ConfigService, GeoZoneService} from 'app/services';
import moment from 'moment';
import {Utils} from 'app/utils';
import {ExportFileTypeEnum} from 'app/models';
import {AppComponent} from 'app/app.component';

@Component({
	selector: 'report-driver-performance',
	templateUrl: './report-driver-performance.component.html',
	styleUrls: ['./report-driver-performance.component.scss'],
	providers: [MessageService]
})
export class ReportDriverPerformanceComponent implements OnInit {
	constructor(public reportXpressService: ReportXpressService,
				public configService: ConfigService,
				public app: AppComponent,
				public messageService: MessageService,
				private geoZoneService: GeoZoneService) {
	}

	public drivers!: any;
	public selectedDateRange: Date[] = [];
	public isLoading: boolean = true;

	public exportFileTypeEnum = ExportFileTypeEnum;

	private searchTimer: number = 0;

	ngOnInit(): void {
		this.selectedDateRange[1] = new Date();
		this.selectedDateRange[0] = new Date();
		this.selectedDateRange[0].setDate(new Date().getDate() - 30);

		this.getDriverPerformanceReport();
	}

	private getDriverPerformanceReport() {
		this.isLoading = true;

		const dto = {
			StartDate: moment(this.selectedDateRange[0]).format('YYYY-MM-DD'),
			EndDate: moment(this.selectedDateRange[1]).format('YYYY-MM-DD'),
			TimeZoneOffset: Utils.getTimezoneOffset()
		};

		this.reportXpressService.getDriverPerformanceReport(dto, this.messageService)
			.then(data => {
				if (!data.Success) {
					this.messageService.add({severity: 'error', summary: 'Error', detail: data.ErrorMessage});
					this.isLoading = false;
					return;
				}
				this.drivers = data.Items;
				this.isLoading = false;
			})
			.catch(err => {
				this.isLoading = false;
				throw err;
			});
	}

	public exportOrdersCompletedAndUnallocated(fileType: ExportFileTypeEnum) {
		this.isLoading = true;

		const dto = {
			StartDate: moment(this.selectedDateRange[0]).format('YYYY-MM-DD'),
			EndDate: moment(this.selectedDateRange[1]).format('YYYY-MM-DD'),
			FileType: fileType,
			TimeZoneOffset: Utils.getTimezoneOffset()
		};

		this.reportXpressService.exportDriverPerformanceReport(dto, this.messageService)
			.then(data => {
				this.messageService.add({severity: 'success', summary: 'Success', detail: 'Success'});
				Utils.saveFileResponse(data, 'Driver performance report ' + moment(new Date()).format('DD MMM YYYY hh:mm:ss A'), fileType);
				this.isLoading = false;
			})
			.catch(err => {
				this.isLoading = false;
				throw err;
			});
	}

	public handleFilterChange(event: any) {
		if (this.searchTimer) {
			window.clearTimeout(this.searchTimer);
		}

		this.searchTimer = window.setTimeout(() => {
			if (!this.selectedDateRange[1]) {
				return;
			}
			this.getDriverPerformanceReport();
			this.searchTimer = 0;
		}, 1500);
	}
}
